import * as SharedDocumentsSelectors from './shared-document.selectors';

export {SharedDocumentsSelectors};
